import React from 'react';
const CTA = () => {
  return <section className="w-full bg-orange-500 py-20" data-id="element-29">
      <div className="container mx-auto px-4 text-center" data-id="element-30">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-31">
          Ready to transform your forms?
        </h2>
        <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-32">
          Join teams building the future of data collection with AI-powered
          conversational forms.
        </p>
        <a href="https://cal.com/fluidform/30min" target="_blank" rel="noopener noreferrer" className="inline-block bg-white text-orange-500 px-8 py-3 rounded-md text-lg font-medium hover:bg-gray-100 transition-colors" data-id="element-33">
          Get Started for Free
        </a>
        <p className="text-white/80 mt-4" data-id="element-34">No credit card required.</p>
      </div>
    </section>;
};
export default CTA;